import { render, staticRenderFns } from "./OssElImage.vue?vue&type=template&id=07cf88e4"
import script from "./OssElImage.vue?vue&type=script&lang=js"
export * from "./OssElImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports